var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"topic"},_vm._l((_vm.teachers),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$router.push({
        name: 'teacher',
        params: { teacher_id: item.id }
      })}}},[_c('van-image',{attrs:{"lazy-load":"","round":"","fit":"cover","src":item.avatar}}),_c('p',{staticClass:"cate_name"},[_vm._v(_vm._s(item.title))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }